import hoistStatics from 'hoist-non-react-statics';

function compose(...wrappingFunctions) {
  return function wrapComponent(OriginalComponent) {
    const result = wrappingFunctions.reduceRight((component, wrappingFunction) => wrappingFunction(component), OriginalComponent);
    return hoistStatics(result, OriginalComponent);
  };
}

export { compose as default };
